// extracted by mini-css-extract-plugin
module.exports = {"main-component":"metricDown_main-component__180dM"};